import Vue from 'vue'


interface LoadContainerOpts {
	
}

export default async (
	el: HTMLElement,
	$el: JQuery<HTMLElement>,
	opt: LoadContainerOpts,
) => {
	
    const app = new Vue({
		el: el,
		data() {
			return {
				isActive: false,
				selectedMenu: '',
			}
		},
		mounted() {
			console.log(this.isActive)
		},
		methods: {
			openHeaderMenu() {
				this.isActive = true
				document.body.classList.add('overflow-hidden')
			},
			closeHeaderMenu() {
				this.isActive = false
				document.body.classList.remove('overflow-hidden')
			},
			clearSelectedMenu() {
				this.selectedMenu = ''
			},
			setSelectedMenu(item: string) {
                this.selectedMenu = item
            }
		},
	})
	
}
